import React, { FC, ReactNode, useEffect, useState } from "react";
import { DEF_PG_SIZE_SUB } from "../../constants/maximum-page-size";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import columns from "../../models/ColumnDefinitions/PresetReaderColumns";
import { ListQuery } from "../../models/ListQuery";
import { Lookup } from "../../models/Lookup";
import LookupTypes from "../../models/LookupTypes";
import searchColumns from '../../models/search/PresetReaderSearch';
import SiteSearch from "../../models/search/SiteSearch";
import { getSiteNamesWithPagination } from "../../services/siteService";
import TableTab from "../tabs/table-tab";
import { PRESET_TYPES } from "../../constants/preset-constants";
import { getDevicesPerPresetType } from "../../services/hardwarePresetService";

interface Props {
    itemId: string,
    children?:ReactNode
}

const PresetReaders: FC<Props> = ({ itemId, children }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.assignedReaders);
    const [lookup, setLookup] = useState<Lookup[]>([]);

    useEffect(() => {
        setLookup([{
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        }]);
    }, []);

    return <TableContextProvider
    dataMethod={(listParameters?: ListQuery) => getDevicesPerPresetType(itemId, PRESET_TYPES.READER, listParameters)}
        tableDescriptor={columns}
        searchDescriptor={searchColumns}
        useTable
        usePagination
        useSearch
        useSort
        useFilter
        maxPageSize={DEF_PG_SIZE_SUB}
        lookup={lookup}>
        <TableTab
            title={title}
            selectRows={false} 
            cyName="presetReaders">{children}</TableTab>
    </TableContextProvider>
};

export default PresetReaders;
